unable to read source [project]/packages/src/utils/legacyClassNameHelper.ts